export default __webpack_public_path__ + "static/loopring-logo-fa078cb1771571200bc85bb36e33286a.svg";